<template>
    <submenu-page
        eyebrow="PLATFORM ADMINISTRATION"
        title="SMS"
        description="Manage schools, school subjects, platform metrics and notifications."
        count-label="admin tools"
    >
        <Submenu />
    </submenu-page>
</template>
<script>


import Submenu from './SubMenu.vue';
export default {
  components: {
    Submenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
    if (
      !(
        userDetails.isSuperAdmin ||
        userDetails.isAdmin ||
        userDetails.isSupportAdmin ||
        userDetails.isAffliateMarketer
      )
    ) {
      this.$store.dispatch("auth/Logout");
      this.$router.push("/login");
    }
  }
};
</script>
<style></style>
